import { createFileRoute } from '@tanstack/react-router'
import { GuestWebsite } from '@/features/wedding-web/pages/guest-website'
export const Route = createFileRoute('/svatba/$token/den')({ component: Page })
function Page() {
  return <GuestWebsite token={Route.useParams().token} dayView />
}
